<template>
    <div>
        <div class="columns is-multiline m-b-10" style="border-bottom:#ddd 0.8px solid;">
            <div class="column is-full is-flex">
                <h2 class="has-text-weight-semibold is-size-4">
                    Basic home section
                </h2>
                <b-switch
                class="m-l-20"
                v-model="basic.display">
                </b-switch>
            </div>

            <div class="column is-two-thirds">
                <b-field label="Decoracion de imagen.">
                    <b-switch
                    v-model="basic.shadowImage">
                    </b-switch>
                </b-field>
                <b-field label="Titulo">
                    <b-input
                    v-model="basic.title"
                    maxlength="70"
                    required>
                    </b-input>
                </b-field>
                <div class="columns">
                    <div class="column is-half">
                        <b-field label="Texto del boton">
                            <b-input
                            v-model="basic.buttonText"
                            maxlength="40"
                            ></b-input>
                        </b-field>
                    </div>
                    <div class="column is-half">
                        <b-field label="Link del boton">
                            <b-input
                            v-model="basic.buttonLink"
                            ></b-input>
                        </b-field>
                    </div>
                </div>
                <b-field label="Texto">
                    <b-input
                    required
                    maxlength="500"
                    type="textarea"
                    rows="10"
                    v-model="basic.text">
                    </b-input>
                </b-field>
            </div>

            <div class="column is-half">
                <b-upload
                v-model="image"
                drag-drop
                @input="encodeImage"
                >
                    <section class="section" >
                        <div class=" has-text-centered">
                            <p>
                                <b-icon
                                    icon="upload"
                                    size="is-large">
                                </b-icon>
                            </p>
                            <p>Drop your files here or click to upload</p>
                        </div>
                    </section>
                </b-upload>
                <div v-if="image" class="tags m-t-20">
                    <span
                        class="tag is-primary" >
                        {{image.name}}
                        <button class="delete is-small"
                            type="button"
                            @click="deleteDropFile">
                        </button>
                    </span>
                </div>
            </div>

            <div class="column is-half has-text-centered">
                <img v-if="basic.image" :src="basic.image" class="img-class">
            </div>

            <div class="column m-b-20 is-full has-text-center">
                <b-button
                type="is-primary"
                rounded
                :loading="loadUploadBasicSection"
                @click="updateBasicHero">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Guardar detalles
                </b-button>
            </div>

        </div>

        <div class="columns is-multiline">
            <div class="column is-full is-flex">
                <h2 class="has-text-weight-semibold is-size-4">
                    Codigo personalizado de seccion.
                </h2>
                <b-switch
                class="m-l-20"
                v-model="custom.display"
                ></b-switch>    
            </div>
            <div class="column is-full">
                <p class="is-size-7">Habilitar las dos opciones va a hacer visible solo la version custom.</p>
            </div>
            <div class="column is-two-thirds">
                <b-field label="Custom HTML code.">
                    <b-input type="textarea"
                    rows="10"
                    v-model="custom.customHtml"></b-input>
                </b-field>
            </div>
            <div class="column is-two-thirds">
                <b-field label="Custom CSS code.">
                    <b-input type="textarea"
                    rows="10"
                    v-model="custom.customCss"></b-input>
                </b-field>
            </div>
            <div class="column is-two-thirds">
                <b-field label="Custom JS code.">
                    <b-input type="textarea"
                     rows="10"
                    v-model="custom.customJs"></b-input>
                </b-field>
            </div>   

            <div class="column m-b-20 is-full has-text-center">
                <b-button
                type="is-primary"
                rounded
                :loading="loadUploadCustom"
                @click="updateCustomHero">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Save custom details
                </b-button>
            </div>

        </div>

    </div>
</template>

<script>
import { getHandler, patchHandler } from '../../../../services/http'
export default {
    props:{
        basicHero:{
            type:String,
            default:""
        },
        customHero:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            basic:{},
            custom:{},
            loading:{},
            image:"",
            loadUploadBasicSection:false,
            loadUploadCustom:false
        }
    },
    methods:{
        async fetchBasicHero(){
            this.loading = true
            let resp = await getHandler(this.basicHero, {error:false, success:false})
            this.basic = resp
            this.loading = false
        },
        async fetchCustomHero(){
            this.loading = true
            let resp = await getHandler(this.customHero, {error:false, success:false})
            this.custom = resp
            this.loading = false
        },
        async updateBasicHero(){
            this.loadUploadBasicSection = true
            let msg = {
                resource:'notify'
            }
            if(this.buttonLink){
                if(!this.basic.buttonLink.includes('http')){
                this.basic.buttonLink = "http://" + this.basic.buttonLink
            }
            }
            let resp = await patchHandler(this.basicHero, this.basic, {error:msg, success:msg})
            this.loadUploadBasicSection = false
        },
        async updateCustomHero(){
            this.loadUploadCustom = true
            let msg = {
                resource:'notify'
            }
            let resp = await patchHandler(this.customHero, this.custom, {error:msg, success:msg})
            this.loadUploadCustom = false
        },
        encodeImage(){
            let reader = new FileReader();
            reader.readAsDataURL(this.image);
            reader.onloadend = (event) => {
                this.basic.image = reader.result
            }
        },
        deleteDropFile(){
            this.image = ""
            this.basic.image = ""
        },
    },
    created(){
        this.fetchBasicHero()
        this.fetchCustomHero()
    }
}
</script>

<style lang="scss" scoped>
.img-class{
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>